import { Link } from "wouter";
import { linkifyPhone, PHONE_HREF } from "@/lib/phone";

interface CTABlockProps {
  title?: string;
  subtitle?: string;
  primaryText?: string;
  secondaryText?: string;
  className?: string;
  theme?: "dark" | "light";
}

export function CTABlock({
  title = "Ready to Upgrade Your Home's Exterior?",
  subtitle = "Contact Graystone Roofing today for a free, no-pressure inspection and estimate.",
  primaryText = "Request a Free Quote",
  secondaryText = "Call 717-725-7170",
  className = "",
  theme = "dark"
}: CTABlockProps) {
  const isDark = theme === "dark";
  
  return (
    <section className={`py-16 px-4 ${isDark ? 'bg-secondary text-secondary-foreground' : 'bg-muted text-foreground'} ${className}`}>
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className={`text-3xl md:text-4xl font-serif font-bold mb-4 ${isDark ? 'text-white' : ''}`}>
          {title}
        </h2>
        <p className={`text-lg mb-8 max-w-2xl mx-auto ${isDark ? 'text-secondary-foreground/90' : 'text-muted-foreground'}`}>
          {linkifyPhone(subtitle, isDark ? "font-semibold text-white underline underline-offset-2 hover:opacity-80" : undefined)}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            href="/contact-graystone-roofing-siding/"
            className="bg-primary text-primary-foreground px-8 py-4 rounded font-bold text-lg hover:bg-primary/90 transition-colors shadow-md"
            data-testid="cta-primary"
          >
            {primaryText}
          </Link>
          <a 
            href={PHONE_HREF}
            className={`px-8 py-4 rounded font-bold text-lg border-2 transition-colors flex items-center justify-center gap-2 ${
              isDark 
                ? 'border-white/20 hover:border-white/40 hover:bg-white/5' 
                : 'border-primary text-primary hover:bg-primary/5'
            }`}
            data-testid="cta-secondary"
          >
            {secondaryText}
          </a>
        </div>
      </div>
    </section>
  );
}
